import React from "react";
import "./Title.css";

const Title = ({ title }) => {
  return <h1 className="main-header">{title}</h1>;
};

export default Title;
